import MathsUtils from '@/utils/mathsUtils'

/**
 * General utility functions for the optimiser station in production
 */
export default class OptimiserUtils {

  /**
   * Calculate the transformed trim values based on rotation/flip
   * 
   * Returns an object with transformed trim values
   */
  static calculateTransformedTrimValues(trimTop, trimRight, trimBottom, trimLeft, angle, flippedHorz, flippedVert) {
    var trimList = [trimTop, trimRight, trimBottom, trimLeft]
    let angleIndex = -MathsUtils.wrapAngleDegrees(angle) / 90

    let wrapIndex = (index) => {
      if(index < 0)
        return trimList.length + index
      return index % trimList.length
    }

    var transformedTrim = {
      trimTop: trimList[wrapIndex(angleIndex)],
      trimRight: trimList[wrapIndex(angleIndex + 1)],
      trimBottom: trimList[wrapIndex(angleIndex + 2)],
      trimLeft: trimList[wrapIndex(angleIndex + 3)]
    }

    if(flippedHorz) {
      let tmp = transformedTrim.trimLeft
      transformedTrim.trimLeft = transformedTrim.trimRight
      transformedTrim.trimRight = tmp
    }
    if(flippedVert) {
      let tmp = transformedTrim.trimTop
      transformedTrim.trimTop = transformedTrim.trimBottom
      transformedTrim.trimBottom = tmp
    }

    return transformedTrim
  }


  /**
   * Calculate the original trim values based on transformed trim details
   * 
   * Returns an object with original-untransformed trim values
   */
  static calculateUntransformedTrimValues(trimTop, trimRight, trimBottom, trimLeft, angle, flippedHorz, flippedVert) {
    if(flippedHorz) {
      let tmp = trimLeft
      trimLeft = trimRight
      trimRight = tmp
    }
    if(flippedVert) {
      let tmp = trimTop
      trimTop = trimBottom
      trimBottom = tmp
    }

    var trimList = [trimTop, trimRight, trimBottom, trimLeft]
    let angleIndex = -MathsUtils.wrapAngleDegrees(-angle) / 90

    let wrapIndex = (index) => {
      if(index < 0)
        return trimList.length + index
      return index % trimList.length
    }

    var transformedTrim = {
      trimTop: trimList[wrapIndex(angleIndex)],
      trimRight: trimList[wrapIndex(angleIndex + 1)],
      trimBottom: trimList[wrapIndex(angleIndex + 2)],
      trimLeft: trimList[wrapIndex(angleIndex + 3)]
    }

    return transformedTrim
  }

}